import { PROCESS_TYPES } from "../services/processesService";
import { parseDateBrToISO } from "./utils";

const TIMELY = 'TEMPESTIVO';
const UNTIMELY = 'INTEMPESTIVO';

export function getLimitDate(process: any): string | null {
    const type = process.tipo;
    const infraction = process.infracao;

    if ([PROCESS_TYPES.IC, PROCESS_TYPES.NA].includes(type.toLowerCase())) {
        return infraction?.data_limite_defesa;
    }

    if ([PROCESS_TYPES.RE, PROCESS_TYPES.CE].includes(type.toLowerCase() )) {
        return null;
    }

    if (infraction?.data_emissao_notificacao_penalidade) {
        const [datePart] = infraction.data_emissao_notificacao_penalidade.split(' ');
        return `${datePart} 23:59:59`;
    }

    return null;
}

export function getKind(process) {
    const dateLimit = getLimitDate(process); // '25/01/2024'
    const creationStr = process.data_criacao?.substring(0, 10); // '27/12/2023'

    const creationDate = parseDateBrToISO(creationStr);
    const limitDate = parseDateBrToISO(dateLimit);

    if (!limitDate || !creationDate || creationDate <= limitDate) {
        return TIMELY;
    } else {
        return UNTIMELY;
    }
}

export function isValidFactsAndFundaments(text) {
  const meaningfulWords = text
    .replace(/[^\w\s]|_/g, "")
    .split(/\s+/)
    .filter((w) => w.length > 3);

  return meaningfulWords.length >= 5;
}